export default __webpack_public_path__ + "static/media/a009-tip3.d2f3f7d6.jpg";